import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Eye, EyeOff } from 'lucide-react';

interface WidgetProps {
  id: string;
  title: string;
  children: React.ReactNode;
  isDragging?: boolean;
  visible: boolean;
  onToggleVisibility?: () => void;
  showControls?: boolean;
  highlightEdit?: boolean;
}

export const Widget: React.FC<WidgetProps> = ({
  id,
  title,
  children,
  visible,
  onToggleVisibility,
  showControls = false,
  highlightEdit = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  if (!visible) return null;

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        padding: '20px',
        position: 'relative',
        cursor: showControls ? (isDragging ? 'grabbing' : 'grab') : 'default',
        border: highlightEdit ? '2px solid #c4b5fd' : '2px solid transparent',
      }}
    >
      {showControls && (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            display: 'flex',
            gap: '8px',
            zIndex: 10,
          }}
        >
          <button
            {...attributes}
            {...listeners}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'grab',
              padding: '4px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              color: '#666',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#f3f4f6';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            title="Arrastar widget"
          >
            <GripVertical size={16} />
          </button>
          {onToggleVisibility && (
            <button
              onClick={onToggleVisibility}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                color: '#666',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              title="Ocultar widget"
            >
              <EyeOff size={16} />
            </button>
          )}
        </div>
      )}
      <div style={{ marginBottom: '10px' }}>
        <h3 style={{ margin: 0, color: '#333', fontSize: '16px', fontWeight: '600' }}>
          {title}
        </h3>
      </div>
      {children}
    </div>
  );
};




















